<template>
  <div id="document-title" />
</template>

<script>
export default {
  mounted() {
    this.setDocumentTitle();
  },
  watch: {
    "$i18n.locale"() {
      this.setDocumentTitle();
    }
  },
  methods: {
    setDocumentTitle() {
      window.document.title = this.$i18n.t("document_title");
    }
  }
};
</script>
